import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
  isEditing: boolean;
  pageId: number;
} = {
  isEditing: false,
  pageId: 0,
};

const aboutPageSlice = createSlice({
  name: "about-page-slice",
  initialState,
  reducers: {
    toggleIsEditing: (state) => {
      state.isEditing = !state.isEditing;
    },
    setPageId: (state, action: PayloadAction<{ pageId: number }>) => {
      state.pageId = action.payload.pageId;
    },
  },
});

export const aboutPageActions = aboutPageSlice.actions;
export default aboutPageSlice;
